module.exports = __webpack_public_path__ + "static/novak-c0b786d588b0b61060e06f9c426414e9.jpg";